export default "__VITE_ASSET__571deac3__"